import { render, staticRenderFns } from "./CityModal.vue?vue&type=template&id=c85b19a4&"
import script from "./CityModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CityModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c85b19a4')) {
      api.createRecord('c85b19a4', component.options)
    } else {
      api.reload('c85b19a4', component.options)
    }
    module.hot.accept("./CityModal.vue?vue&type=template&id=c85b19a4&", function () {
      api.rerender('c85b19a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/components/CityModal.vue"
export default component.exports